import React, {useRef, useState} from "react";
import {Button, Collapse, ListGroup, Spinner} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChevronDown, faChevronUp, faMinusCircle} from "@fortawesome/free-solid-svg-icons";
import TextSlider from "../textSlider";
import {useHistogram} from "./RulesContext";
import HistogramContainer from "../../components/Histogram/HistogramContainer";

const RulesEditDistanceGSEntry = (props) => {
    const [showHistogram, setShowHistogram] = useState(false);
    const { getHistogramForOrgans, isLoading } = useHistogram();

    const histogramRef = useRef(null);

    const histogramData = getHistogramForOrgans(props.data.organ, props.data.organ);
    function setPoints(val) {
        props.data.grading = val;
        props.cb(props.data);
    }

    function setPercentage(val) {
        props.data.percentage = val;
        props.cb(props.data);
    }

    function setDistance(val) {
        props.data.threshold = val;
        props.cb(props.data);
    }
    const handleCollapseEnter = () => {
        // Allow a small delay for the collapse animation to complete
            if (histogramRef.current?.state.graphPanel) {
                histogramRef.current.state.graphPanel.resize();
            }

    };

    return (
        <ListGroup.Item className="p-0">
            <div className="d-flex justify-content-between align-items-start p-3">
                <div className="d-flex align-items-center gap-2">
                    <Button
                        variant="link"
                        className="p-0 text-muted"
                        onClick={() => setShowHistogram(!showHistogram)}
                    >
                        <FontAwesomeIcon icon={showHistogram ? faChevronUp : faChevronDown} />
                    </Button>
                    <span>
            Increase grade by
            <TextSlider
                min={0}
                max={100}
                value={Math.round((props.data.grading/props.total)*100)}
                onChange={setPoints}
                display={(value) => <span> ({value}%) points</span>}
            />
            if
            <TextSlider
                min={0}
                max={100}
                value={props.data.percentage}
                onChange={setPercentage}
                display={(value) => <span>({value}%)</span>}
            />
            is within
            <TextSlider
                rate={0.1}
                min={0}
                max={100}
                value={props.data.threshold}
                onChange={setDistance}
                display={(value) => <span>({value} mm)</span>}
            />
          </span>
                </div>
                <button onClick={() => props.cb(null)} className="ms-2 btn btn-link text-danger">
                    <FontAwesomeIcon className="pe-auto" icon={faMinusCircle} />
                </button>
            </div>
            <Collapse in={showHistogram} onEntered={handleCollapseEnter}>
                <div className="px-3 pb-3">
                    {isLoading ? (
                        <Spinner animation="border" size="sm" />
                    ) : histogramData ? (
                        <HistogramContainer
                            ref={histogramRef}
                            labels={histogramData.labels}
                            data={histogramData.data}

                            selectedPercentageIndex={props.data.percentage}
                            selectedDistanceThreshold={props.data.threshold}
                        />
                    ) : (
                        <div className="text-muted">No histogram data available</div>
                    )}
                </div>
            </Collapse>
        </ListGroup.Item>
    );
};

export default RulesEditDistanceGSEntry;